<template lang="pug">
  div.wrap-item-lecture-list
    ItemCardLecture(
      v-if="lectures"
      v-for="(item, index) in lectures"
      :index="index"
      :content="item"
      :isSubscribed="isSubscribed"
      @showModalWindow="() => { $emit('showModalWindow') }")
</template>

<style lang="scss" scoped>
.wrap-item-lecture-list {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
}
</style>

<script>
import db, { firebase } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')

import ItemCardLecture from '@/components/item/ItemCardLecture'

export default {
  components: {
    ItemCardLecture
  },
  props: {
    course: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
    // subscribedCourse: {
    //   type: Object,
    //   required: true
    // }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      isSubscribed: false,
      lectures: null,
    }
  },
  async created () {
    this.lectures = this.course.lectures.map((e, i) => {
      e.num = i
      return e
    })
    this.isSubscribed = this.user.plans.includes(this.$route.params.id)
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    }
  }
}
</script>
